// src/screens/RefundPolicy.js
import React from "react";
import "../styles/LegalPage.css";

export default function RefundPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <h1>Pay2Pee Refund &amp; Cancellation Policy</h1>
        <p className="legal-meta">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <p>
          This Refund &amp; Cancellation Policy explains how refunds and
          cancellations are handled for purchases made through the Pay2Pee app.
          By using Pay2Pee, you agree to this Policy.
        </p>

        <p>
          Website:{" "}
          <a
            href="https://pay2pee.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://pay2pee.app
          </a>
          <br />
          Email: <a href="mailto:support@pay2pee.app">support@pay2pee.app</a>
        </p>

        <h2>1. Pay-Per-Visit Purchases</h2>
        <p>
          Pay2Pee allows guests to purchase one-time restroom access passes.
          Because these are digital, time-sensitive services, refunds are not
          automatically guaranteed.
        </p>
        <p>However, we may grant refunds in situations such as:</p>
        <ul>
          <li>The restroom was unavailable or locked</li>
          <li>The host refused to honor a valid pass</li>
          <li>
            The restroom was clearly unsafe or not as described (for example,
            unusable or severely unsanitary)
          </li>
          <li>
            A technical issue within the app or payment system prevented you
            from using your pass
          </li>
        </ul>
        <p>
          To request a refund, email{" "}
          <a href="mailto:support@pay2pee.app">support@pay2pee.app</a> with:
        </p>
        <ul>
          <li>Your account email</li>
          <li>Date and time of the visit</li>
          <li>Location name</li>
          <li>A brief description of the issue</li>
        </ul>

        <h2>2. Weekly and Monthly Subscriptions</h2>
        <p>
          Pay2Pee may offer weekly or monthly passes that allow multiple
          restroom visits within a billing period.
        </p>

        <h3>2.1 Apple App Store Subscriptions</h3>
        <p>
          If you purchased a subscription through the Apple App Store, Apple
          handles billing and refunds. We cannot issue direct refunds for
          purchases made through Apple.
        </p>
        <p>
          To request a refund, go to your Apple account settings and use
          Apple&apos;s refund process.
        </p>

        <h3>2.2 Google Play Subscriptions</h3>
        <p>
          If you purchased a subscription through Google Play, refunds are
          handled through Google Play&apos;s refund system. We cannot directly
          refund Google Play subscriptions.
        </p>

        <h3>2.3 Subscriptions Purchased with Stripe</h3>
        <p>
          If your subscription was billed directly via Stripe (for example,
          through in-app purchase screens that use Stripe checkout), we may
          issue refunds in cases such as:
        </p>
        <ul>
          <li>Duplicate or accidental charges</li>
          <li>Unauthorized use of your payment method</li>
          <li>Technical issues preventing use of your pass</li>
        </ul>
        <p>
          For Stripe-based subscriptions, contact{" "}
          <a href="mailto:support@pay2pee.app">support@pay2pee.app</a>.
        </p>

        <h2>3. Host Payouts</h2>
        <p>
          Payouts made to hosts via Stripe Connect are considered final once
          transferred to the host&apos;s connected account or bank. We generally
          cannot reverse completed payouts.
        </p>

        <h2>4. Account Cancellation</h2>
        <p>
          You may cancel your account at any time by contacting{" "}
          <a href="mailto:support@pay2pee.app">support@pay2pee.app</a>.
        </p>
        <p>
          Cancelling your account will stop future charges for subscriptions
          managed directly by Pay2Pee (e.g., Stripe subscriptions). It does not
          automatically refund past payments.
        </p>

        <h2>5. How to Contact Us</h2>
        <p>
          For questions or refund requests, contact our support team at{" "}
          <a href="mailto:support@pay2pee.app">support@pay2pee.app</a>.
        </p>
      </div>
    </div>
  );
}
